// src/left-menu/index.js
import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Sidebar,
  SidebarHeader,
  SidebarBody,
  SidebarFooter,
} from "../../catalyst/sidebar";
import { Switch } from "@headlessui/react";
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'; //"react-beautiful-dnd";
import { ReactComponent as SectionIcon } from "./sections.svg";
import { Auth } from "aws-amplify";
import {
  setRightMenuWidth,
  setSelectedSectionAndPage,
  setCurrentSurvey,
  updateTabStates,
} from "../../store/actions";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { updateSurveyFromAPI } from "../../services/surveyService";

const DesignRightMenu = () => {
  const themeMode = useSelector((state) => state.themeMode);
  // const currentSurvey = useSelector((state) => state.currentSurvey);
  // const selectedSectionAndPage = useSelector(
  //   (state) => state.selectedSectionAndPage
  // );
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  const currentSurvey = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurvey;
  const selectedSectionAndPage = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.selectedSectionAndPage;

  const dispatch = useDispatch();

  let [token, setToken] = useState("");
  const [width, setWidth] = useState(350); // Başlangıç genişliği
  //   const [rightMenuWidth, setLeftMenuWidth] = useState(350); // Başlangıç genişliği
  const [isResizing, setIsResizing] = useState(false);
  const [menuVisibilityState, setMenuVisibilityState] = useState("Show Menu");
  const [expanded, setExpanded] = useState(true); // Menü genişletme durumu
  const [openMenu, setOpenMenu] = useState(null);
  const [visibleTooltip, setVisibleTooltip] = useState({});
  const [rightMenuContent, setRightMenuContent] = useState("sections");
  const [clickedParamParentId, setClickedParamParentId] = useState(0);
  const [clickedParam, setClickedParam] = useState("section");
  const [clickedParamId, setClickedParamId] = useState(0);
  const surveyActionMenuRef = useRef(null);
  const [deleteAllowMenuOpen, setDeleteAllowMenuOpen] = useState(false);
  const [deleteInfoMenuShow, setDeleteInfoMenuShow] = useState(false);
  const [selectedParam, setSelectedParam] = useState({
    param: null,
    index: null,
    parentIndex: null,
  });
  const [infoText, setInfoText] = useState("");
  async function checkAuth() {
    // window.location.reload();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) {
      // console.log('Unable to refresh Token', e);
    }
  }

  async function getToken(token) {
    if (token) {
      setToken(token);
    } else {
      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    }
  }

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    if (token.length > 0) {
      // console.log("Token:", token);
    }
  }, [token]);

  const handleClickOutside = (event) => {
    // Eğer tıklama menü dışında gerçekleştiyse, menüyü kapat
    if (
      surveyActionMenuRef.current &&
      !surveyActionMenuRef.current.contains(event.target)
    ) {
      setOpenMenu(false);
    }
  };
  const handleClick = (param, id, sectionIndex) => {
    setClickedParamParentId(sectionIndex);
    setClickedParam(param);
    setClickedParamId(id);
    if (param === "section") {
      if (sections.length > 0) {
        // dispatch(
        //   setSelectedSectionAndPage({
        //     sectionName: sections[sectionIndex].name,
        //     sectionIndex: sectionIndex,
        //     pageName: "All",
        //   })
        // );
        dispatch(
          updateTabStates(topMenuTabs.activeTab, "selectedSectionAndPage", {
            sectionName: sections[sectionIndex].name,
            sectionIndex: sectionIndex,
            pageName: "All",
          })
        );
      }
    } else if (param === "page") {
      // dispatch(
      //   setSelectedSectionAndPage({
      //     sectionName: sections[sectionIndex].name,
      //     sectionIndex: sectionIndex,
      //     pageName: sections[sectionIndex].pages[id].name,
      //   })
      // );
      dispatch(
        updateTabStates(topMenuTabs.activeTab, "selectedSectionAndPage", {
          sectionName: sections[sectionIndex].name,
          sectionIndex: sectionIndex,
          pageName: sections[sectionIndex].pages[id].name,
        })
      );
    }
  };

  useEffect(() => {
    console.log(clickedParam, clickedParamId);
  }, [clickedParam, clickedParamId]);

  useEffect(() => {
    // Tıklama olayını dinle
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Component unmount olduğunda event listener'ı kaldır
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleMouseEnter = (id) => {
    console.log(id);
    setVisibleTooltip((prev) => ({ ...prev, [id]: true }));
  };

  const handleMouseLeave = (id) => {
    setVisibleTooltip((prev) => ({ ...prev, [id]: false }));
  };

  const menuRef = useRef(null);

  const handleMouseMove = (e) => {
    if (isResizing) {
      const maxWidth = window.innerWidth * 0.33; // Menü genişliği, ekran genişliğinin %33'ü kadar olacak
      const newWidth = Math.min(Math.max(e.clientX, 300), maxWidth); // Fare x pozisyonu 70px ile maxWidth arasında olacak
      setWidth(newWidth);
    }
  };
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (menuRef.current) {
        const newWidth = menuRef.current.offsetWidth;
        dispatch(setRightMenuWidth(newWidth + 68));
        // dispatch(updateTabStates(topMenuTabs.activeTab, 'rightMenuWidth', newWidth + 68));
      }
    });

    if (menuRef.current) {
      resizeObserver.observe(menuRef.current);
    }
    return () => {
      if (menuRef.current) {
        resizeObserver.unobserve(menuRef.current);
      }
    };
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1280) {
        setExpanded(false);
      }
      if (window.innerWidth < 640) {
        setWidth(300);
      }
    };

    // İlk kontrol ve dinleyici ekleme
    handleResize();
    window.addEventListener("resize", handleResize);

    // Cleanup listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const handleToggleWidth = (e) => {
    setMenuVisibilityState(expanded ? "Show Menu" : "Hide Menu");
    console.log(expanded);
    setExpanded(!expanded);
    if (isResizing) {
      setWidth(window.innerWidth * 0.33);
    }
  };
  // Tooltip'in hangi öğe için görünür olduğunu takip ederiz.

  const toggleOptionsMenu = () => {
    if (rightMenuContent !== "options") {
      if (!expanded) {
        handleToggleWidth();
      }
      setRightMenuContent("options");
    } else {
      handleToggleWidth();
    }
  };

  const toggleSectionsMenu = () => {
    if (rightMenuContent !== "sections") {
      if (!expanded) {
        handleToggleWidth();
      }
      setRightMenuContent("sections");
    } else {
      handleToggleWidth();
    }
  };

  const menuItems = [
    { id: 1, name: "Menu Visibility", tooltipContent: menuVisibilityState },
    { id: 2, name: "Home", tooltipContent: "Home" },
    { id: 3, name: "Surveys", tooltipContent: "Surveys" },
  ];
  const handleMouseDown = () => {
    setIsResizing(true);
  };
  const handleMouseUp = () => {
    setIsResizing(false);
  };
  React.useEffect(() => {
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isResizing]);

  const [showPageTitles, setShowPageTitles] = useState(currentSurvey?.content?.showPageTitles);
  const [showPageTitlesInProgressBar, setShowPageTitlesInProgressBar] = useState(currentSurvey?.content?.progressBarShowPageTitles);
  const [showPageNumbersInProgressBar, setShowPageNumbersInProgressBar] = useState(currentSurvey?.content?.progressBarShowPageNumbers);

  const [showQuestionNumbers, setShowQuestionNumbers] = useState([
    {
      value: 1,
      name: "on",
      selected: currentSurvey?.content?.showQuestionNumbers === "on"
    },
    {
      value: 2,
      name: "off",
      selected: currentSurvey?.content?.showQuestionNumbers === "off"
    },
  ]);

  const [questionsOnPageMode, setQuestionsOnPageMode] = useState([
    {
      value: 1,
      name: "standard",
      selected: currentSurvey?.content?.questionsOnPageMode === "standard"
    },
    {
      value: 2,
      name: "single",
      selected: currentSurvey?.content?.questionsOnPageMode === "single"
    },
  ]);

  const [showProgressBar, setShowProgressBar] = useState([
    {
      value: 1,
      name: "off",
      selected: currentSurvey?.content?.showProgressBar === "off"
    },
    {
      value: 2,
      name: "auto",
      selected: currentSurvey?.content?.showProgressBar === "auto"
    },
    {
      value: 3,
      name: "top",
      selected: currentSurvey?.content?.showProgressBar === "top"
    },
    {
      value: 4,
      name: "aboveHeader",
      selected: currentSurvey?.content?.showProgressBar === "aboveHeader"
    },
    {
      value: 5,
      name: "belowHeader",
      selected: currentSurvey?.content?.showProgressBar === "belowHeader"
    },
    {
      value: 6,
      name: "bottom",
      selected: currentSurvey?.content?.showProgressBar === "bottom"
    },
    {
      value: 6,
      name: "topBottom",
      selected: currentSurvey?.content?.showProgressBar === "topBottom"
    },
  ]);

  const [progressBarType, setProgressBarType] = useState([
    {
      value: 1,
      name: "pages",
      selected: currentSurvey?.content?.progressBarType === "pages"
    },
    {
      value: 2,
      name: "questions",
      selected: currentSurvey?.content?.progressBarType === "questions"
    },
  ]);

  const [visibleShowQuestionNumbers, setVisibleShowQuestionNumbers] =
    useState(false);
  const [visibleQuestionsOnPageMode, setVisibleQuestionsOnPageMode] =
    useState(false);
  const [visibleShowProgressBar, setVisibleShowProgressBar] = useState(false);
  const [visibleProgressBarType, setVisibleProgressBarType] = useState(false);
  const visibleShowQuestionNumbersRef=useRef(null)
  const visibleQuestionsOnPageModeRef=useRef(null)
  const visibleShowProgressBarRef=useRef(null)
  const visibleProgressBarTypeRef=useRef(null)
      const handleClickDropdownOutside = (event, ref, setState) => {
          if (ref.current && !ref.current.contains(event.target)) {
              setState(false) // Eğer dışarıya tıklanırsa, ilgili modalı kapat
          }
      };
      useEffect(() => {
          if (visibleShowQuestionNumbers) {
              document.addEventListener('click', (event) => handleClickDropdownOutside(event, visibleShowQuestionNumbersRef, setVisibleShowQuestionNumbers));
          }
  
          if (visibleQuestionsOnPageMode) {
              document.addEventListener('click', (event) => handleClickDropdownOutside(event, visibleQuestionsOnPageModeRef, setVisibleQuestionsOnPageMode));
          }
          if (visibleShowProgressBar) {
            document.addEventListener('click', (event) => handleClickDropdownOutside(event, visibleShowProgressBarRef, setVisibleShowProgressBar));
        }

        if (visibleProgressBarType) {
            document.addEventListener('click', (event) => handleClickDropdownOutside(event, visibleProgressBarTypeRef, setVisibleProgressBarType));
        }

          return () => {
              document.removeEventListener('click', (event) => handleClickDropdownOutside(event, visibleShowQuestionNumbersRef, setVisibleShowQuestionNumbers));
              document.removeEventListener('click', (event) => handleClickDropdownOutside(event, visibleQuestionsOnPageModeRef, setVisibleQuestionsOnPageMode));
              document.removeEventListener('click', (event) => handleClickDropdownOutside(event, visibleShowProgressBarRef, setVisibleShowProgressBar));
              document.removeEventListener('click', (event) =>  handleClickDropdownOutside(event, visibleProgressBarTypeRef, setVisibleProgressBarType));
          };
      }, [visibleShowQuestionNumbers, visibleQuestionsOnPageMode,visibleShowProgressBar,visibleProgressBarType]);
  const handleSQNClick = (sqn) => {
    let _currentSurvey = JSON.parse(JSON.stringify(currentSurvey));
    _currentSurvey.content.showQuestionNumbers = sqn.name;
    updateSurveyContent(_currentSurvey);

    setShowQuestionNumbers(
      showQuestionNumbers.map((x) => {
        if (x.value === sqn.value) {
          x.selected = true;
        } else {
          x.selected = false;
        }
        return x;
      })
    );
    setVisibleShowQuestionNumbers(false);
  };

  const handleOPMClick = (opm) => {
    let _currentSurvey = JSON.parse(JSON.stringify(currentSurvey));
    _currentSurvey.content.questionsOnPageMode = opm.name;
    updateSurveyContent(_currentSurvey);

    setQuestionsOnPageMode(
      questionsOnPageMode.map((x) => {
        if (x.value === opm.value) {
          x.selected = true;
        } else {
          x.selected = false;
        }
        return x;
      })
    );
    setVisibleQuestionsOnPageMode(false);
  };

  const handleSPBClick = (spb) => {
    let _currentSurvey = JSON.parse(JSON.stringify(currentSurvey));
    _currentSurvey.content.showProgressBar = spb.name;
    updateSurveyContent(_currentSurvey);

    setShowProgressBar(
      showProgressBar.map((x) => {
        if (x.value === spb.value) {
          x.selected = true;
        } else {
          x.selected = false;
        }
        return x;
      })
    );
    setVisibleShowProgressBar(false);
  };

  const handlePBTClick = (pbt) => {
    let _currentSurvey = JSON.parse(JSON.stringify(currentSurvey));
    _currentSurvey.content.progressBarType = pbt.name;
    updateSurveyContent(_currentSurvey);
    
    setProgressBarType(
      progressBarType.map((x) => {
        if (x.value === pbt.value) {
          x.selected = true;
        } else {
          x.selected = false;
        }
        return x;
      })
    );
    setVisibleProgressBarType(false);
  };

  const updateSPT = (value) => {
    let _currentSurvey = JSON.parse(JSON.stringify(currentSurvey));
    _currentSurvey.content.showPageTitles = value;
    updateSurveyContent(_currentSurvey);

    setShowPageTitles(value);
  };

  const updateSPTIPB = (value) => {
    let _currentSurvey = JSON.parse(JSON.stringify(currentSurvey));
    _currentSurvey.content.progressBarShowPageTitles = value;
    updateSurveyContent(_currentSurvey);

    setShowPageTitlesInProgressBar(value)
  };

  const updateSPNIPB = (value) => {
    let _currentSurvey = JSON.parse(JSON.stringify(currentSurvey));
    _currentSurvey.content.progressBarShowPageNumbers = value;
    updateSurveyContent(_currentSurvey);

    setShowPageNumbersInProgressBar(value)
  };

  const [sections, setSections] = useState([]);
  const [sectionName, setSectionName] = useState("");
  const [pageName, setPageName] = useState("");

  useEffect(() => {
    if (currentSurvey) {
      console.log("currentSurveyyy:", currentSurvey);
      let _newSections = [];
      currentSurvey?.content?.pages.forEach((sect) => {
        if (sect.name !== "intro") {
          let _newSection = {
            name: sect.name,
            pages: [],
            newPageName: "",
          };
          sect.elements[0].elements
            .filter((element) => element.type === "html")
            .forEach((page) => {
              _newSection.pages.push({ name: page.name });
            });
          _newSections.push(_newSection);
        }
      });
      console.log("_newSections:", _newSections);
      setSections(_newSections);
      console.log("selectedSectionAndPage:", selectedSectionAndPage);
      console.log(
        "selectedSectionAndPage.sectionName",
        selectedSectionAndPage.sectionName
      );
      if (selectedSectionAndPage.sectionName === undefined) {
        // dispatch(
        //   setSelectedSectionAndPage({
        //     sectionName: _newSections[0]?.name,
        //     sectionIndex: 0,
        //     pageName: "All",
        //   })
        // );
        dispatch(
          updateTabStates(topMenuTabs.activeTab, "selectedSectionAndPage", {
            sectionName: _newSections[0]?.name,
            sectionIndex: 0,
            pageName: "All",
          })
        );
      }
    }
  }, [currentSurvey]);

  const handleAddSection = (e) => {
    if (e.key === "Enter" || e.type === "blur") {
      if (sectionName !== "") {
        let _currentSurvey = { ...currentSurvey };
        if (_currentSurvey.content.pages.filter((x) => x.name === sectionName).length === 0) {

          const updatedSections = [...sections, { name: sectionName, pages: [], newPageName: "" }];
          setSections(updatedSections);

          _currentSurvey.content.pages.push({
            name: sectionName,
            title: sectionName,
            elements: [
              {
                type: "panel",
                name: sectionName,
                elements: [],
              },
            ],
          });

          updateSurveyContent(_currentSurvey);

          setSectionName("");
        }
      }
    }
  };

  const updateSection = (value, index) => {
    const updatedSections = sections.map((section, i) => {
      if (i === index) {
        return { ...section, name: value };
      }
      return section;
    });
    setSections(updatedSections);
  };

  const applyUpdateSection = (e, index) => {
    if (e.key === "Enter" || e.type === "blur") {
      let _currentSurvey = { ...currentSurvey };
      _currentSurvey.content.pages.filter((x) => x.name !== "intro")[
        index
      ].name = sections[index].name;
      _currentSurvey.content.pages.filter((x) => x.name !== "intro")[
        index
      ].title = sections[index].name;

      updateSurveyContent(_currentSurvey);
    }
  };

  const handleAddPage = (e, sectionIndex) => {
    if (e.key === "Enter" || e.type === "blur") {
      if (sections[sectionIndex].newPageName !== "") {
        let _currentSurvey = { ...currentSurvey };
        if (sections.map((section) => section.pages).flat().filter((x) => x.name === sections[sectionIndex].newPageName).length === 0) {

          const updatedSections = sections.map((section, i) => {
            if (i === sectionIndex) {
              return {
                ...section,
                pages: [...section.pages, { name: section.newPageName }],
                newPageName: "",
              };
            }
            return section;
          });
          setSections(updatedSections);

          _currentSurvey.content.pages
            .filter((x) => x.name !== "intro")
          [sectionIndex].elements[0].elements.push({
            type: "html",
            name: sections[sectionIndex].newPageName,
            html: "<h5>" + sections[sectionIndex].newPageName + "</h5>",
          });

          updateSurveyContent(_currentSurvey);
        }
      }
    }
  };

  const updatePage = (value, sectionIndex, pageIndex) => {
    const updatedSections = sections.map((section, i) => {
      if (i === sectionIndex) {
        const updatedPages = section.pages.map((page, j) => {
          if (j === pageIndex) {
            return { name: value };
          }
          return page;
        });
        return { ...section, pages: updatedPages };
      }
      return section;
    });
    setSections(updatedSections);
  };

  const applyUpdatePage = (e, sectionIndex, pageIndex) => {
    if (e.key === "Enter" || e.type === "blur") {
      let _currentSurvey = { ...currentSurvey };
      _currentSurvey.content.pages
        .filter((x) => x.name !== "intro")
      [sectionIndex].elements[0].elements.filter(
        (element) => element.type === "html"
      )[pageIndex].name = sections[sectionIndex].pages[pageIndex].name;
      _currentSurvey.content.pages
        .filter((x) => x.name !== "intro")
      [sectionIndex].elements[0].elements.filter(
        (element) => element.type === "html"
      )[pageIndex].html =
        "<h5>" + sections[sectionIndex].pages[pageIndex].name + "</h5>";

      updateSurveyContent(_currentSurvey);
    }
  };

  async function updateSurveyContent(_currentSurvey) {
    try {
      _currentSurvey["willUpdate"] = true;
      const obj = {
        content: _currentSurvey.content,
      };
      await updateSurveyFromAPI(token, obj, _currentSurvey.ID)
        .then((result) => {
          console.log("update survey result : ", result);
          // dispatch(setCurrentSurvey(_currentSurvey));
          dispatch(
            updateTabStates(
              topMenuTabs.activeTab,
              "currentSurvey",
              _currentSurvey
            )
          );
        })
        .catch((error) => {
          console.log("update survey error : ", error);
        });
    } catch (error) {
      console.log("update survey error : ", error);
    }
  }

  const handleDragEnd = (result) => {
    console.log(result);
    if (!result.destination) return;

    const { source, destination, type } = result;
    console.log("source:", source);
    console.log("destination:", destination);

    if (type === "section") {
      // Bölümleri yeniden sırala
      const updatedSections = Array.from(sections);
      const [movedSectionn] = updatedSections.splice(source.index, 1);
      updatedSections.splice(destination.index, 0, movedSectionn);
      setSections(updatedSections);

      let _currentSurvey = { ...currentSurvey };
      let movedSection = {};
      // const movedSection = _currentSurvey.content.pages.filter(x => x.name !== "intro")[source.index];
      if (
        _currentSurvey.content.pages.filter((x) => x.name === "intro").length >
        0
      ) {
        [movedSection] = _currentSurvey.content.pages.splice(
          source.index + 1,
          1
        );
        _currentSurvey.content.pages.splice(
          destination.index + 1,
          0,
          movedSection
        );
      } else {
        [movedSection] = _currentSurvey.content.pages.splice(source.index, 1);
        _currentSurvey.content.pages.splice(destination.index, 0, movedSection);
      }
      console.log("_currentSurvey:", _currentSurvey);
      if (clickedParamParentId === source.index) {
        setClickedParamParentId(destination.index);
      } else if (clickedParamParentId === destination.index) {
        setClickedParamParentId(source.index);
      }
      updateSurveyContent(_currentSurvey);
    } else if (type === "page") {
      // Sayfaları yeniden sırala
      const sourceSectionIndex = parseInt(source.droppableId); // Kaynak bölüm
      const destinationSectionIndex = parseInt(destination.droppableId); // Hedef bölüm

      const sourceSection = sections[sourceSectionIndex];
      const destinationSection = sections[destinationSectionIndex];

      const updatedSourcePages = Array.from(sourceSection.pages);
      const [movedPage] = updatedSourcePages.splice(source.index, 1);

      if (sourceSectionIndex === destinationSectionIndex) {
        // Aynı bölüm içinde sayfa taşınıyor
        updatedSourcePages.splice(destination.index, 0, movedPage);
        const updatedSections = sections.map((section, index) =>
          index === sourceSectionIndex
            ? { ...section, pages: updatedSourcePages }
            : section
        );
        setSections(updatedSections);

        const _currentSurvey = { ...currentSurvey };
        const sourcePageIndex = _currentSurvey.content.pages
          .filter((x) => x.name !== "intro")
        [sourceSectionIndex].elements[0].elements.findIndex(
          (element) =>
            element.type === "html" && element.name === movedPage.name
        );
        const fromSourceToEnd = _currentSurvey.content.pages
          .filter((x) => x.name !== "intro")
        [sourceSectionIndex].elements[0].elements.slice(sourcePageIndex + 1);
        let willMoveElements = [
          _currentSurvey.content.pages.filter((x) => x.name !== "intro")[
            sourceSectionIndex
          ].elements[0].elements[sourcePageIndex],
        ];
        let willDeleteIndexes = [sourcePageIndex];
        let last = false;
        fromSourceToEnd.forEach((element, index) => {
          if (last) return;
          if (element.type === "html") {
            last = true;
          } else {
            willMoveElements.push(element);
            willDeleteIndexes.push(sourcePageIndex + index + 1);
          }
        });
        for (let i = willDeleteIndexes.length - 1; i >= 0; i--) {
          const index = willDeleteIndexes[i];
          _currentSurvey.content.pages
            .filter((x) => x.name !== "intro")
          [sourceSectionIndex].elements[0].elements.splice(index, 1); // Belirtilen indeksi sil
        }
        let destinationIndex = destination.index;
        if (destinationIndex !== 0) {
          let htmlPages = 0;
          _currentSurvey.content.pages
            .filter((x) => x.name !== "intro")
          [destinationSectionIndex].elements[0].elements.forEach(
            (element, index) => {
              if (element.type === "html") {
                ++htmlPages;
                if (htmlPages === destination.index + 1) {
                  destinationIndex = index;
                }
              }
            }
          );
          if (destinationIndex === destination.index) {
            destinationIndex = _currentSurvey.content.pages.filter(
              (x) => x.name !== "intro"
            )[destinationSectionIndex].elements[0].elements.length;
          }
        }
        console.log("destinationIndex:", destinationIndex);
        _currentSurvey.content.pages
          .filter((x) => x.name !== "intro")
        [destinationSectionIndex].elements[0].elements.splice(
          destinationIndex,
          0,
          ...willMoveElements
        );

        updateSurveyContent(_currentSurvey);
      } else {
        // Farklı bölümler arasında sayfa taşınıyor
        const updatedDestinationPages = Array.from(destinationSection.pages);
        updatedDestinationPages.splice(destination.index, 0, movedPage);

        const updatedSections = sections.map((section, index) => {
          if (index === sourceSectionIndex) {
            return { ...section, pages: updatedSourcePages };
          } else if (index === destinationSectionIndex) {
            return { ...section, pages: updatedDestinationPages };
          }
          return section;
        });
        setSections(updatedSections);

        const _currentSurvey = { ...currentSurvey };
        const sourcePageIndex = _currentSurvey.content.pages
          .filter((x) => x.name !== "intro")
        [sourceSectionIndex].elements[0].elements.findIndex(
          (element) =>
            element.type === "html" && element.name === movedPage.name
        );
        const fromSourceToEnd = _currentSurvey.content.pages
          .filter((x) => x.name !== "intro")
        [sourceSectionIndex].elements[0].elements.slice(sourcePageIndex + 1);
        let willMoveElements = [
          _currentSurvey.content.pages.filter((x) => x.name !== "intro")[
            sourceSectionIndex
          ].elements[0].elements[sourcePageIndex],
        ];
        let willDeleteIndexes = [sourcePageIndex];
        let last = false;
        fromSourceToEnd.forEach((element, index) => {
          if (last) return;
          if (element.type === "html") {
            last = true;
          } else {
            willMoveElements.push(element);
            willDeleteIndexes.push(sourcePageIndex + index + 1);
          }
        });
        console.log(
          "currentelements before delete:",
          _currentSurvey.content.pages.filter((x) => x.name !== "intro")[
            sourceSectionIndex
          ].elements[0].elements
        );
        console.log("willDeleteIndexes:", willDeleteIndexes);
        for (let i = willDeleteIndexes.length - 1; i >= 0; i--) {
          const index = willDeleteIndexes[i];
          console.log("deleting index:", index);
          _currentSurvey.content.pages
            .filter((x) => x.name !== "intro")
          [sourceSectionIndex].elements[0].elements.splice(index, 1); // Belirtilen indeksi sil
        }
        let destinationIndex = destination.index;
        if (destinationIndex !== 0) {
          let htmlPages = 0;
          _currentSurvey.content.pages
            .filter((x) => x.name !== "intro")
          [destinationSectionIndex].elements[0].elements.forEach(
            (element, index) => {
              if (element.type === "html") {
                ++htmlPages;
                if (htmlPages === destination.index + 1) {
                  destinationIndex = index;
                }
              }
            }
          );
          if (destinationIndex === destination.index) {
            destinationIndex = _currentSurvey.content.pages.filter(
              (x) => x.name !== "intro"
            )[destinationSectionIndex].elements[0].elements.length;
          }
        }
        console.log("destinationIndex:", destinationIndex);
        _currentSurvey.content.pages
          .filter((x) => x.name !== "intro")
        [destinationSectionIndex].elements[0].elements.splice(
          destinationIndex,
          0,
          ...willMoveElements
        );

        updateSurveyContent(_currentSurvey);
      }
    }
  };

  const updateNewPageName = (value, sectionIndex) => {
    const updatedSections = sections.map((section, i) => {
      if (i === sectionIndex) {
        return { ...section, newPageName: value };
      }
      return section;
    });
    setSections(updatedSections);
  };

  const handleDeleteSection = (sectionIndex) => {
    setDeleteAllowMenuOpen(false);
    setDeleteInfoMenuShow(true);
    let _currentSurvey = { ...currentSurvey };
    const sectionName = sections[sectionIndex].name;
    // const section = _currentSurvey.content.pages.filter(x => x.name !== "intro")[sectionIndex];
    // const sectionIndexInSurvey = _currentSurvey.content.pages.filter(x => x.name !== "intro").indexOf(section);
    _currentSurvey.content.pages.splice(
      _currentSurvey.content.pages.findIndex((x) => x.name === sectionName),
      1
    );
    console.log("_currentSurvey:", _currentSurvey);
    console.log('111111111-1', selectedSectionAndPage.sectionName);
    console.log('111111111-2', sectionName);
    console.log('111111111-3', sections);
    if (selectedSectionAndPage.sectionName === sectionName) {
      //active
      setClickedParamParentId(0);
      setClickedParam("section");
      // dispatch(
      //   setSelectedSectionAndPage({
      //     sectionName: sections[0].name,
      //     sectionIndex: 0,
      //     pageName: "All",
      //   })
      // );
      dispatch(
        updateTabStates(topMenuTabs.activeTab, "selectedSectionAndPage", {
          sectionName: sections.filter(x => x.name !== selectedSectionAndPage.sectionName)[0]?.name,
          sectionIndex: 0,
          pageName: "All",
        })
      );
    }
    updateSurveyContent(_currentSurvey);
  };

  const handleDeletePage = (sectionIndex, pageIndex) => {
    setDeleteAllowMenuOpen(false);
    setDeleteInfoMenuShow(true);
    let _currentSurvey = { ...currentSurvey };
    const pageName = sections[sectionIndex].pages[pageIndex].name;
    const page = _currentSurvey.content.pages
      .filter((x) => x.name !== "intro")
    [sectionIndex].elements[0].elements.find(
      (element) => element.type === "html" && element.name === pageName
    );
    const pageIndexInSurvey = _currentSurvey.content.pages
      .filter((x) => x.name !== "intro")
    [sectionIndex].elements[0].elements.indexOf(page);

    //get the questions of page and delete them
    const fromSourceToEnd = _currentSurvey.content.pages
      .filter((x) => x.name !== "intro")
    [sectionIndex].elements[0].elements.slice(pageIndexInSurvey + 1);
    let willDeleteIndexes = [pageIndexInSurvey];
    let last = false;
    fromSourceToEnd.forEach((element, index) => {
      if (last) return;
      if (element.type === "html") {
        last = true;
      } else {
        willDeleteIndexes.push(pageIndexInSurvey + index + 1);
      }
    });
    for (let i = willDeleteIndexes.length - 1; i >= 0; i--) {
      const index = willDeleteIndexes[i];
      _currentSurvey.content.pages
        .filter((x) => x.name !== "intro")
      [sectionIndex].elements[0].elements.splice(index, 1); // Belirtilen indeksi sil
    }

    // _currentSurvey.content.pages.filter(x => x.name !== "intro")[sectionIndex].elements[0].elements.splice(pageIndexInSurvey, 1);
    console.log("_currentSurvey:", _currentSurvey);
    if (selectedSectionAndPage.pageName === pageName) {
      //active
      setClickedParamParentId(sectionIndex);
      setClickedParam("section");
      // dispatch(
      //   setSelectedSectionAndPage({
      //     sectionName: sections[sectionIndex].name,
      //     sectionIndex: sectionIndex,
      //     pageName: "All",
      //   })
      // );
      dispatch(
        updateTabStates(topMenuTabs.activeTab, "selectedSectionAndPage", {
          sectionName: sections[sectionIndex].name,
          sectionIndex: sectionIndex,
          pageName: "All",
        })
      );
    }
    updateSurveyContent(_currentSurvey);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setDeleteInfoMenuShow(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [deleteInfoMenuShow, setDeleteInfoMenuShow]);
  return (
    <>
      <div className={`flex fixed  right-0 h-full 
          ${currentSurvey.status !== "Draft" ? "cursor:auto pointer-events-none opacity-50" : ""}
        `}>
        <div
          ref={menuRef}
          className={`flex h-screen justify-between border-r border-l overflow-y-auto scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-500 
            ${themeMode === "dark"
              ? "bg-[#14141f] border-white/5"
              : "bg-[#fbfbfc]"
            }
            ${expanded ? "block" : "hidden "} 
           `}
          style={{ width: `${width}px` }}
        >
          {rightMenuContent === "options" && (
            <div className="w-auto md:w-screen">
              <div
                className={`hidden sm:block overflow-x-auto overflow-y-hidden -mx-1 flex flex-row items-center justify-between py-2 h-[50px] border-b border-solid px-4 ${themeMode === "dark" ? "border-white-06" : "border-black-06"
                  }`}
              >
                <div className="flex items-center justify-between pl-3 h-full">
                  <span
                    className={`font-bold text-[1rem] ${themeMode === "dark" ? "text-[#C1C9D6]" : "text-[#5A667E]"
                      }`}
                  >
                    Options
                  </span>
                  {/* <span className="border-r h-[2rem] border-white/5 pl-[8rem]"></span> */}
                  <span
                    className="text-[#C1C9D6] hover:bg-[#d1d5de1a] p-2 rounded-md cursor-pointer"
                    onClick={handleToggleWidth}
                  >
                    <svg
                      className="size-4"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M3.14645 3.14645C2.95118 3.34171 2.95118 3.65829 3.14645 3.85355L7.29289 8L3.14645 12.1464C2.95118 12.3417 2.95118 12.6583 3.14645 12.8536C3.34171 13.0488 3.65829 13.0488 3.85355 12.8536L8 8.70711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.70711 8L12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8 7.29289L3.85355 3.14645C3.65829 2.95118 3.34171 2.95118 3.14645 3.14645Z"></path>
                    </svg>
                  </span>
                </div>
              </div>
              <div className="flex flex-col items-center justify-start gap-4 p-4 w-full rounded-md">
                <div className="flex flex-row w-full items-center">
                  <div
                    className={`${themeMode === "dark" ? "text-white" : "text-[#5A667E]"
                      } text-[0.875rem] w-1/2`}
                  >
                    Show question numbers
                  </div>
                  <div className="relative pl-8"   ref={visibleShowQuestionNumbersRef}>
                    <button
                      className={`${themeMode === "dark"
                        ? "text-white bg-[#2c3040] hover:bg-[#ffffff0a] border-black-09"
                        : "text-[#5A667E] bg-gray-100 border-white-09"
                        }  text-[0.875rem] px-2 border    rounded-md`}
                      onClick={() => {
                        setVisibleShowQuestionNumbers(
                          !visibleShowQuestionNumbers
                        );
                        setVisibleProgressBarType(false);
                        setVisibleQuestionsOnPageMode(false);
                        setVisibleShowProgressBar(false);
                      }}
                    >
                      {showQuestionNumbers.find((x) => x.selected)?.name}
                    </button>
                    {visibleShowQuestionNumbers && (
                      <div
                        className={`absolute flex flex-col top-7 right-10 left-8 min-w-[100px] w-auto border max-h-auto overflow-y-auto rounded-md z-[10000] ${themeMode === "dark"
                          ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                          : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                          }`}
                        
                      >
                        {showQuestionNumbers.map((sqn) => (
                          <div
                            key={sqn.value}
                            className={`flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer ${themeMode === "dark"
                              ? "text-white bg-[#2c3040] hover:bg-[#ffffff0a] border-black-09"
                              : "text-[#5A667E] bg-gray-100 hover:bg-gray-200 border-white-09"
                              }`}
                            onClick={() => handleSQNClick(sqn)}
                          >
                            <div className="flex items-center justify-start">
                              <span className="ml-1">{sqn.name}</span>
                            </div>
                            {sqn.selected && (
                              <div>
                                <svg
                                  className="size-3 mt-1"
                                  viewBox="0 0 16 16"
                                  fill="currentColor"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clipRule="evenodd"
                                    d="M14.8536 3.14645C15.0488 3.34171 15.0488 3.65829 14.8536 3.85355L6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645C2.34171 6.95118 2.65829 6.95118 2.85355 7.14645L6.5 10.7929L14.1464 3.14645C14.3417 2.95118 14.6583 2.95118 14.8536 3.14645Z"
                                  ></path>
                                </svg>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-row w-full items-center">
                  <div
                    className={`${themeMode === "dark" ? "text-white" : "text-[#5A667E]"
                      } text-[0.875rem] w-1/2`}
                  >
                    Questions on page mode
                  </div>
                  <div className="relative pl-8 pl-8" ref={visibleQuestionsOnPageModeRef}>
                    <button
                      className={`${themeMode === "dark"
                        ? "text-white bg-[#2c3040] hover:bg-[#ffffff0a] border-black-09"
                        : "text-[#5A667E] bg-gray-100  border-white-09"
                        } text-[0.875rem] px-2 border    rounded-md`}
                      onClick={() => {
                        setVisibleShowQuestionNumbers(false);
                        setVisibleProgressBarType(false);
                        setVisibleShowProgressBar(false);
                        setVisibleQuestionsOnPageMode(
                          !visibleQuestionsOnPageMode
                        );
                      }}
                    >
                      {questionsOnPageMode.find((x) => x.selected)?.name}
                    </button>
                    {visibleQuestionsOnPageMode && (
                      <div
                        className={`absolute flex flex-col top-7 left-8 min-w-[100px] w-auto border max-h-auto overflow-y-auto rounded-md z-[10000] ${themeMode === "dark"
                          ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                          : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                          }`} 
                      >
                        {questionsOnPageMode.map((opm) => (
                          <div
                            key={opm.value}
                            className={`flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer ${themeMode === "dark"
                              ? "text-white bg-[#2c3040] hover:bg-[#ffffff0a] border-black-09"
                              : "text-[#5A667E] bg-gray-100 hover:bg-gray-200 border-white-09"
                              }`}
                            onClick={() => handleOPMClick(opm)}
                          >
                            <div className="flex items-center justify-start">
                              <span className="ml-1">{opm.name}</span>
                            </div>
                            {opm.selected && (
                              <div>
                                <svg
                                  className="size-3 mt-1"
                                  viewBox="0 0 16 16"
                                  fill="currentColor"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clipRule="evenodd"
                                    d="M14.8536 3.14645C15.0488 3.34171 15.0488 3.65829 14.8536 3.85355L6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645C2.34171 6.95118 2.65829 6.95118 2.85355 7.14645L6.5 10.7929L14.1464 3.14645C14.3417 2.95118 14.6583 2.95118 14.8536 3.14645Z"
                                  ></path>
                                </svg>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-row w-full items-center">
                  <div
                    className={`${themeMode === "dark" ? "text-white" : "text-[#5A667E]"
                      } text-[0.875rem] w-1/2`}
                  >
                    Show progress bar
                  </div>
                  <div className="relative pl-8"  ref={visibleShowProgressBarRef}>
                    <button
                      className={`${themeMode === "dark"
                        ? "text-white bg-[#2c3040] hover:bg-[#ffffff0a] border-black-09"
                        : "text-[#5A667E] bg-gray-100 hover:bg-gray-200 border-white-09"
                        } text-[0.875rem] px-2 border    rounded-md`}
                      onClick={() => {
                        setVisibleShowQuestionNumbers(false);
                        setVisibleProgressBarType(false);
                        setVisibleShowProgressBar(!visibleShowProgressBar);
                        setVisibleQuestionsOnPageMode(false);
                      }}
                    >
                      {showProgressBar.find((x) => x.selected)?.name}
                    </button>
                    {visibleShowProgressBar && (
                      <div
                        className={`absolute flex flex-col top-7 left-8 min-w-[130px] w-auto border max-h-auto overflow-y-auto rounded-md z-[10000] ${themeMode === "dark"
                          ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                          : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                          }`}
                         
                      > 
                        {showProgressBar.map((spb) => (
                          <div
                            key={spb.value}
                            className={`flex items-center justify-between p-1  cursor-pointer ${themeMode === "dark"
                              ? "text-white bg-[#2c3040] hover:bg-[#ffffff0a] border-black-09"
                              : "text-[#5A667E] bg-gray-100 hover:bg-gray-200 border-white-09"
                              }`}
                            onClick={() => handleSPBClick(spb)}
                          >
                            <div className="flex items-center justify-start">
                              <span className="ml-1">{spb.name}</span>
                            </div>
                            {spb.selected && (
                              <div>
                                <svg
                                  className="size-3 mt-1"
                                  viewBox="0 0 16 16"
                                  fill="currentColor"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clipRule="evenodd"
                                    d="M14.8536 3.14645C15.0488 3.34171 15.0488 3.65829 14.8536 3.85355L6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645C2.34171 6.95118 2.65829 6.95118 2.85355 7.14645L6.5 10.7929L14.1464 3.14645C14.3417 2.95118 14.6583 2.95118 14.8536 3.14645Z"
                                  ></path>
                                </svg>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-row w-full items-center">
                  <div
                    className={`${themeMode === "dark" ? "text-white" : "text-[#5A667E]"
                      } text-[0.875rem] w-1/2`}
                  >
                    Progress bar type
                  </div>
                  <div className="relative pl-8" ref={visibleProgressBarTypeRef}>
                    <button
                      className={`${themeMode === "dark"
                        ? "text-white bg-[#2c3040] hover:bg-[#ffffff0a] border-black-09"
                        : "text-[#5A667E] bg-gray-100 hover:bg-gray-200 border-white-09"
                        } text-[0.875rem] px-2 border    rounded-md`}
                      onClick={() => {
                        setVisibleShowQuestionNumbers(false);
                        setVisibleProgressBarType(!visibleProgressBarType);
                        setVisibleShowProgressBar(false);
                        setVisibleQuestionsOnPageMode(false);
                      }}
                    >
                      {progressBarType.find((x) => x.selected)?.name}
                    </button>
                    {visibleProgressBarType && (
                      <div
                        className={`absolute flex flex-col top-7 right-0 left-8 min-w-[100px] w-auto border max-h-auto overflow-y-auto rounded-md z-[10000] ${themeMode === "dark"
                          ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                          : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                          }`} 
                      >
                        {progressBarType.map((pbt) => (
                          <div
                            key={pbt.value}
                            className={`flex items-center justify-between p-1  cursor-pointer ${themeMode === "dark"
                              ? "text-white bg-[#2c3040] hover:bg-[#ffffff0a] border-black-09"
                              : "text-[#5A667E] bg-gray-100 hover:bg-gray-200 border-white-09"
                              }`}
                            onClick={() => handlePBTClick(pbt)}
                          >
                            <div className="flex items-center justify-start">
                              <span className="ml-1">{pbt.name}</span>
                            </div>
                            {pbt.selected && (
                              <div>
                                <svg
                                  className="size-3 mt-1"
                                  viewBox="0 0 16 16"
                                  fill="currentColor"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clipRule="evenodd"
                                    d="M14.8536 3.14645C15.0488 3.34171 15.0488 3.65829 14.8536 3.85355L6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645C2.34171 6.95118 2.65829 6.95118 2.85355 7.14645L6.5 10.7929L14.1464 3.14645C14.3417 2.95118 14.6583 2.95118 14.8536 3.14645Z"
                                  ></path>
                                </svg>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-row w-full items-center">
                  <div
                    className={`${themeMode === "dark" ? "text-white" : "text-[#5A667E]"
                      } text-[0.875rem] w-1/2`}
                  >
                    Show page titles
                  </div>
                  <Switch
                    checked={showPageTitles}
                    onChange={() => updateSPT(!showPageTitles)}
                    className="group relative ml-8 inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                  >
                    <span className="sr-only">Use setting</span>
                    <span
                      aria-hidden="true"
                      className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                    />
                  </Switch>
                </div>
                <div className="flex flex-row w-full items-center">
                  <div
                    className={`${themeMode === "dark" ? "text-white" : "text-[#5A667E]"
                      } text-[0.875rem] w-1/2`}
                  >
                    Show page titles in the progress bar
                  </div>
                  <Switch
                    checked={showPageTitlesInProgressBar}
                    onChange={() => updateSPTIPB(!showPageTitlesInProgressBar)}
                    className="group relative ml-8 inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                  >
                    <span className="sr-only">Use setting</span>
                    <span
                      aria-hidden="true"
                      className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                    />
                  </Switch>
                </div>
                <div className="flex flex-row w-full items-center">
                  <div
                    className={`${themeMode === "dark" ? "text-white" : "text-[#5A667E]"
                      } text-[0.875rem] w-1/2`}
                  >
                    Show page numbers in the progress bar
                  </div>
                  <Switch
                    checked={showPageNumbersInProgressBar}
                    onChange={() => updateSPNIPB(!showPageNumbersInProgressBar)}
                    className="group relative ml-8 inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                  >
                    <span className="sr-only">Use setting</span>
                    <span
                      aria-hidden="true"
                      className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                    />
                  </Switch>
                </div>
              </div>
            </div>
          )}
          {rightMenuContent === "sections" && (
            <div className="w-screen">
              <div
                className={`hidden sm:block overflow-x-auto overflow-y-hidden -mx-1 flex flex-row items-center justify-between py-2 h-[50px] border-b border-solid px-4 ${themeMode === "dark" ? "border-white-06" : "border-black-06"
                  }`}
              >
                <div className="flex items-center justify-between pl-3 h-full">
                  <span
                    className={`font-bold text-[1rem] ${themeMode === "dark" ? "text-[#C1C9D6]" : "text-[#5A667E]"
                      }`}
                  >
                    Sections
                  </span>
                  {/* <span className="border-r h-[2rem] border-white/5 pl-[8rem]"></span> */}
                  <span
                    className="text-[#C1C9D6] hover:bg-[#d1d5de1a] p-2 rounded-md cursor-pointer"
                    onClick={handleToggleWidth}
                  >
                    <svg
                      className="size-4"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M3.14645 3.14645C2.95118 3.34171 2.95118 3.65829 3.14645 3.85355L7.29289 8L3.14645 12.1464C2.95118 12.3417 2.95118 12.6583 3.14645 12.8536C3.34171 13.0488 3.65829 13.0488 3.85355 12.8536L8 8.70711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.70711 8L12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8 7.29289L3.85355 3.14645C3.65829 2.95118 3.34171 2.95118 3.14645 3.14645Z"></path>
                    </svg>
                  </span>
                </div>
              </div>
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="sections" type="section">
                  {(provided) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className="flex flex-col w-full items-center max-h-[90%] overflow-y-auto p-3"
                    >
                      <div
                        className={`flex flex-row w-full items-center p-2 rounded-md `}
                      >
                        {/*${(themeMode === 'dark' ? "hover:bg-[#2c3040]" : "hover:bg-[#F7F7F8]")} */}
                        <div className="mr-2 text-[#C1C9D6]">
                          {/* Add Section Icon */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            className="w-4 h-4"
                          >
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                          </svg>
                        </div>
                        <input
                          className={`w-full text-[.875rem] border-0 bg-transparent focus-visible:outline-none ${themeMode === "dark"
                            ? "text-white "
                            : "text-[#5A667E]"
                            }`}
                          type="text"
                          placeholder="Add a section"
                          value={sectionName}
                          onChange={(e) => setSectionName(e.target.value)}
                          onKeyDown={(e) => handleAddSection(e)}
                          onBlur={(e) => handleAddSection(e)}
                        />
                      </div>
                      {sections.map((section, sectionIndex) => (
                        <Draggable
                          key={sectionIndex}
                          draggableId={`section-${sectionIndex}`}
                          index={sectionIndex}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              className={`w-full flex flex-col mb-4 p-1 rounded-md ${themeMode === "dark" ? "" : ""
                                }`}
                            >
                              {/*hover:bg-[#2A2939] hover:bg-[#F7F7F8]*/}
                              <div
                                className="flex items-center mb-2 group"
                                {...provided.dragHandleProps}
                              >
                                <div className="mr-2">
                                  {/* Section Icon */}
                                  <span
                                    className={`flex  p-2 rounded-md cursor-pointer ${clickedParamParentId === sectionIndex &&
                                      clickedParam === "section"
                                      ? "placeholder:text-[#4d7ff5] text-[#4d7ff5]" // clicked durumunda tema kontrolü yapılmaz
                                      : "text-[#C1C9D6]"
                                      }  ${themeMode === "dark"
                                        ? "hover:bg-[#d1d5de1a] "
                                        : "hover:bg-[#1725471a]"
                                      }`}
                                    onClick={() =>
                                      handleClick("section", "", sectionIndex)
                                    }
                                  >
                                    <SectionIcon
                                      fill="currentColor" // İç kısmı da renklendirebiliriz.
                                      viewBox="0 0 24 24"
                                      strokeWidth="1.5"
                                      stroke="currentColor"
                                      className={`size-4 ${themeMode === "dark"
                                        ? "hover:text-[rgba(255,_255,_255,_0.8)]"
                                        : "hover:text-black"
                                        }`}
                                    />
                                  </span>
                                </div>
                                <input
                                  className={`w-full text-[.875rem] border-0 bg-transparent focus-visible:outline-none h-8 rounded-[0.375rem] font-bold pl-2 ${clickedParamParentId === sectionIndex &&
                                    clickedParam === "section"
                                    ? "placeholder:text-[#4d7ff5] text-[#4d7ff5]" // clicked durumunda tema kontrolü yapılmaz
                                    : ""
                                    } 
                                  ${!(
                                      clickedParamParentId === sectionIndex &&
                                      clickedParam === "section"
                                    ) // clicked durumu sağlanmamışsa
                                      ? themeMode === "dark"
                                        ? "text-[#8e99af] placeholder:text-[#8e99af] hover:bg-[#A5BDFF1A]"
                                        : "text-[#5A667E] hover:bg-[#f0f0f0]"
                                      : ""
                                    } `}
                                  type="text"
                                  value={section.name}
                                  onChange={(e) =>
                                    updateSection(e.target.value, sectionIndex)
                                  }
                                  onKeyDown={(e) =>
                                    applyUpdateSection(e, sectionIndex)
                                  }
                                  onBlur={(e) =>
                                    applyUpdateSection(e, sectionIndex)
                                  }
                                />
                                <button
                                  title="Delete Section"
                                  className={`hidden group-hover:block flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${themeMode === "dark"
                                    ? "text-[#FFFFFF]"
                                    : "text-black"
                                    } cursor-pointer group inline-flex items-center  py-1 pl-2 text-sm font-medium min-w-[1.5rem] max-w-[4.9rem]"`}
                                  onClick={() => {
                                    setSelectedParam({
                                      param: "section",
                                      index: sectionIndex,
                                      parentIndex: 0,
                                    });
                                    console.log("js", selectedParam.param);
                                    setDeleteAllowMenuOpen(true);
                                    setInfoText(
                                      `Are you sure you want to delete ${section.name} section?`
                                    );
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="size-4"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                    />
                                  </svg>
                                </button>
                              </div>

                              {/* Pages Drag & Drop */}
                              <Droppable
                                droppableId={`${sectionIndex}`}
                                type="page"
                                direction="vertical"
                              >
                                {(provided) => (
                                  <div
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                    className="ml-4 flex flex-col w-full min-h-[5px]"
                                  >
                                    {section.pages.map((page, pageIndex) => (
                                      <Draggable
                                        key={pageIndex}
                                        draggableId={`page-${sectionIndex}-${pageIndex}`}
                                        index={pageIndex}
                                      >
                                        {(provided) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className={`group flex items-center p-1 pb-0 mr-4 rounded-md  ${clickedParamParentId ===
                                              sectionIndex &&
                                              clickedParam === "page" &&
                                              clickedParamId === pageIndex
                                              ? themeMode === "dark"
                                                ? "bg-[#1b1d2a]"
                                                : "bg-[#1725471a]"
                                              : ""
                                              } 
                                            
                                            `}
                                          >
                                            <div className="mr-2 ">
                                              {/* Page Icon */}
                                              <span
                                                className={`flex  p-1 rounded-md cursor-pointer ${clickedParamParentId ===
                                                  sectionIndex &&
                                                  clickedParam === "page" &&
                                                  clickedParamId === pageIndex
                                                  ? "text-[#4d7ff5]"
                                                  : "text-[#C1C9D6]"
                                                  }`}
                                                onClick={() =>
                                                  handleClick(
                                                    "page",
                                                    pageIndex,
                                                    sectionIndex
                                                  )
                                                }
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  fill="none"
                                                  viewBox="0 0 24 24"
                                                  strokeWidth="1.5"
                                                  stroke="currentColor"
                                                  className="size-4"
                                                >
                                                  <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M19.5 21.75h-15A2.25 2.25 0 0 1 2.25 19.5v-15A2.25 2.25 0 0 1 4.5 2.25h9.379c.597 0 1.169.237 1.591.659l5.621 5.621c.422.422.659.994.659 1.591V19.5a2.25 2.25 0 0 1-2.25 2.25ZM14.25 2.25v4.5a1.5 1.5 0 0 0 1.5 1.5h4.5"
                                                  />
                                                </svg>
                                              </span>
                                            </div>
                                            <input
                                              className={`w-full text-[0.875rem] border-0 bg-transparent focus-visible:outline-none h-8 rounded-[0.375rem] pl-2
                                              ${clickedParamParentId ===
                                                  sectionIndex &&
                                                  clickedParam === "page" &&
                                                  clickedParamId === pageIndex
                                                  ? "placeholder:text-[#4d7ff5] text-[#4d7ff5]" // clicked durumunda tema kontrolü yapılmaz
                                                  : ""
                                                } 
                                              ${!(
                                                  clickedParamParentId ===
                                                  sectionIndex &&
                                                  clickedParam === "page" &&
                                                  clickedParamId === pageIndex
                                                ) // clicked durumu sağlanmamışsa
                                                  ? themeMode === "dark"
                                                    ? "placeholder:text-white text-white hover:bg-[#A5BDFF1A]" // dark tema
                                                    : "placeholder:text-[#5A667E] text-[#5A667E] hover:bg-[#f0f0f0]" // default tema
                                                  : ""
                                                }`}
                                              type="text"
                                              value={page.name}
                                              onChange={(e) =>
                                                updatePage(
                                                  e.target.value,
                                                  sectionIndex,
                                                  pageIndex
                                                )
                                              }
                                              onKeyDown={(e) =>
                                                applyUpdatePage(
                                                  e,
                                                  sectionIndex,
                                                  pageIndex
                                                )
                                              }
                                              onBlur={(e) =>
                                                applyUpdatePage(
                                                  e,
                                                  sectionIndex,
                                                  pageIndex
                                                )
                                              }
                                            />
                                            <button
                                              title="Delete Page"
                                              className={`hidden group-hover:block flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${themeMode === "dark"
                                                ? "text-[#FFFFFF]"
                                                : "text-black"
                                                } cursor-pointer group inline-flex items-center  py-1 pl-2 text-sm font-medium min-w-[1.5rem] max-w-[4.9rem]"`}
                                              onClick={() => {
                                                setSelectedParam({
                                                  param: "page",
                                                  index: pageIndex,
                                                  parentIndex: sectionIndex,
                                                });
                                                setDeleteAllowMenuOpen(true);
                                                setInfoText(
                                                  `Are you sure you want to delete ${page.name} page?`
                                                );
                                              }}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth="1.5"
                                                stroke="currentColor"
                                                className="size-4"
                                              >
                                                <path
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                                />
                                              </svg>
                                            </button>
                                          </div>
                                        )}
                                      </Draggable>
                                    ))}
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Droppable>

                              {/* Add Page Input */}
                              <div className="flex items-center p-2 ml-4 rounded-md">
                                <div className="mr-2 text-[#C1C9D6]">
                                  {/* Add Page Icon */}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 16 16"
                                    className="w-4 h-4"
                                  >
                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                  </svg>
                                </div>
                                <input
                                  className={`w-full text-[0.875rem] border-0 bg-transparent focus-visible:outline-none ${themeMode === "dark"
                                    ? "text-white"
                                    : "text-[#5A667E]"
                                    }`}
                                  type="text"
                                  placeholder="Add a page"
                                  value={section.newPageName}
                                  onChange={(e) =>
                                    updateNewPageName(
                                      e.target.value,
                                      sectionIndex
                                    )
                                  }
                                  onKeyDown={(e) =>
                                    handleAddPage(e, sectionIndex)
                                  }
                                  onBlur={(e) => handleAddPage(e, sectionIndex)}
                                />
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          )}
        </div>

        {/* <div
          className="absolute top-0 right-0 h-full w-1 bg-white-600 cursor-col-resize"
          onMouseDown={handleMouseDown}
        /> */}
        <Sidebar
          className={`border-r w-[4.25rem]  ${themeMode === "dark" ? "border-white-opacity-10" : ""
            } `}
        >
          <SidebarHeader
            className={`border-b-0 ${themeMode === "dark" ? "bg-[#14141f]" : "bg-[#fbfbfc]"
              }`}
          >
            <ul>
              <li
                className="cursor-pointer relative"
                onMouseEnter={() => handleMouseEnter(1)} // Tooltip görünür yapılıyor
                onMouseLeave={() => handleMouseLeave(1)}
              >
                <div
                  className={`mb-4 group relative flex justify-center rounded  text-[#7F7F7F] hover:font-normal ${themeMode === "dark"
                    ? " hover:text-[rgba(255,_255,_255,_0.8)]"
                    : " hover:text-black "
                    }`}
                  onClick={toggleOptionsMenu}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    className="size-6"
                    strokeWidth="1.5"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  {visibleTooltip[1] && (
                    <div
                      className={`tooltip absolute right z-[10000] flex justify-center w-[6.2rem] top-[13px] right-[calc(32px+0.75rem)] transform -translate-y-1/2 p-2 text-center text-xs ${themeMode === "dark"
                        ? "text-[#FFF] bg-theme-tooltip-bg"
                        : "text-black bg-[#efeff2]"
                        } border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center`}
                    >
                      Options
                    </div>
                  )}
                </div>
              </li>
              <li
                className="cursor-pointer relative"
                onMouseEnter={() => handleMouseEnter(2)} // Tooltip görünür yapılıyor
                onMouseLeave={() => handleMouseLeave(2)}
              >
                <div
                  className={`mb-4 group relative flex justify-center rounded  text-[#7F7F7F] hover:font-normal ${themeMode === "dark"
                    ? " hover:text-[rgba(255,_255,_255,_0.8)]"
                    : " hover:text-black "
                    }`}
                  onClick={toggleSectionsMenu}
                >
                  <SectionIcon
                    fill="currentColor" // İç kısmı da renklendirebiliriz.
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className={`size-4 text-[#7F7F7F] ${themeMode === "dark"
                      ? "hover:text-[rgba(255,_255,_255,_0.8)]"
                      : "hover:text-black"
                      }`}
                  />

                  {visibleTooltip[2] && (
                    <div
                      className={`tooltip absolute right z-[10000] flex justify-center w-[6.2rem] top-[13px] right-[calc(32px+0.75rem)] transform -translate-y-1/2 p-2 text-center text-xs ${themeMode === "dark"
                        ? "text-[#FFF] bg-theme-tooltip-bg"
                        : "text-black bg-[#efeff2]"
                        } border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center`}
                    >
                      Sections
                    </div>
                  )}
                </div>
              </li>
            </ul>
          </SidebarHeader>
          <SidebarBody
            className={`pt-0 border-b-0 border-t-0  overflow-auto z[999] ${themeMode === "dark" ? "bg-[#14141f] " : "bg-[#fbfbfc] "
              }`}
          >
            <ul className="mb-11"></ul>
          </SidebarBody>
          <SidebarFooter
            className={` border-t-0 sticky bottom-0   ${themeMode === "dark" ? "bg-[#14141f] " : "bg-[#fbfbfc]  "
              }`}
          >
            <div className="flex justify-center flex-col"></div>
          </SidebarFooter>
        </Sidebar>
        <Dialog
          open={deleteAllowMenuOpen}
          onClose={setDeleteAllowMenuOpen}
          className="relative z-10"
        >
          <DialogBackdrop
            transition
            className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
                  } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
              >
                <div>
                  <div className="mt-0 text-start sm:mt-0">
                    <DialogTitle
                      as="h3"
                      className={`text-base font-semibold ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                        }`}
                    >
                      Delete selected <span>{selectedParam.param}</span>
                    </DialogTitle>
                    <div className="mt-1">
                      <p
                        className={`text-sm ${themeMode === "dark" ? "text-white-8" : "text-black-8"
                          }`}
                      >
                        {infoText}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                  <button
                    type="button"
                    onClick={() =>
                      selectedParam.param === "section"
                        ? handleDeleteSection(selectedParam.index)
                        : handleDeletePage(
                          selectedParam.parentIndex,
                          selectedParam.index
                        )
                    }
                    className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                      } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    data-autofocus
                    onClick={() => setDeleteAllowMenuOpen(false)}
                    className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid ${themeMode === "dark"
                      ? "bg-white-02 border-white-09 text-white-8 hover:text-white hover:bg-white-04"
                      : "bg-black-02 border-black-09 text-black-8 hover:text-black hover:bg-black-04"
                      } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-1 sm:mt-0`}
                  >
                    No
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
        <Dialog
          open={deleteInfoMenuShow}
          onClose={setDeleteInfoMenuShow}
          className="relative z-10"
        >
          <DialogBackdrop
            transition
            className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
            <div className="flex min-h-full items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
              <DialogPanel
                transition
                className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
                  } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
              >
                <div>
                  <div className="mt-0 text-start sm:mt-0">
                    <DialogTitle
                      as="h3"
                      className={`text-base font-semibold flex flex-row justify-start ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                        }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          fill="#008000"
                          stroke="#fff"
                        />
                      </svg>
                      Selected {selectedParam.param} deleted
                    </DialogTitle>
                  </div>
                </div>
                <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                  <button
                    type="button"
                    onClick={() => setDeleteInfoMenuShow(false)}
                    className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                      } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                  >
                    Ok
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default DesignRightMenu;
